<template>
  <div>
    <div class="condition-section">
      <div class="cond-row">
        <div class="item">
          <div style="margin-right: 10px">过户状态：</div>
          <Select
            class="height45"
            v-model="transferStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in transferStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item">
          <Input
            class="height45"
            v-model="domainName"
            placeholder="请输入搜索的域名名称"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="btn-height45" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="table-data">
      <div class="total">搜索结果（{{ total }}）</div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="transferStatus" slot-scope="{ row }">
          <div>
            {{ row.transferStatus | status }}
          </div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getTemplatesTransferList } from "api/domain.js";
export default {
  name: "templatesTransferList",
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "未处理";
          break;
        case 1:
          title = "处理中";
          break;
        case 2:
          title = "成功";
          break;
        case 3:
          title = "失败";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      transferStatus: "",
      transferStatusList: [
        {
          value: 0,
          label: "未处理",
        },
        {
          value: 1,
          label: "处理中",
        },
        {
          value: 2,
          label: "成功",
        },
        {
          value: 3,
          label: "失败",
        },
      ],
      domainName: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "域名",
          align: "center",
          key: "domainName",
        },
        {
          title: "模板名称",
          align: "center",
          key: "templateName",
        },
        {
          title: "原模板",
          align: "center",
          key: "oldTemplateName",
        },
        {
          title: "创建时间",
          align: "center",
          key: "createdAt",
        },
        {
          title: "过户状态",
          align: "center",
          slot: "transferStatus",
        },
        {
          title: "完成时间",
          align: "center",
          key: "finishedAt",
        },
      ],
      data: [],
      tableLoading: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          domainName: this.domainName,
          transferStatus: this.transferStatus,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await getTemplatesTransferList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.domainName = "";
      this.transferStatus = "";
      this.onPageChange(1);
    },
  },
};
</script>
<style lang="less" scoped>
.condition-section {
  margin: 40px 0 0;
  background-color: #fff;
  padding: 40px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #f0f3f6;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 80px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
